if (!customElements.get('product-add-on')) {
  customElements.define('product-add-on',
    class ProductAddOn extends HTMLElement {
      constructor() {
        super()

        this.variantIdChangedUnsubscriber = undefined
        this.swatches = this.querySelectorAll('[js-product-add-on="swatch"]')
        this.selectedSwatchTitle = this.querySelector('[js-product-add-on="title"]')
        this.productForm = new FormData(document.querySelector('.product-form form'))
      }

      connectedCallback() {
        this.setEventListeners()
      }

      setNodes() {
        this.swatches = this.querySelectorAll('[js-product-add-on="swatch"]')
        this.selectedSwatchTitle = this.querySelector('[js-product-add-on="title"]')
      }

      setEventListeners() {
        this.variantIdChangedUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, () => {
          this.handleMasterVariantChange()
        })

        this.swatches.forEach(swatch => {
          swatch.addEventListener('click', this.handleSwatchChange.bind(this))
        })
      }

      handleMasterVariantChange() {
        this.setNodes()
        this.handleGalleryUpdate()

        this.swatches.forEach(swatch => {
          swatch.addEventListener('click', this.handleSwatchChange.bind(this))
        })
      }

      handleSwatchChange(event) {
        const label = window.variantStrings.productAddOnTitle
        const title = event.target.dataset.title

        if (!title) {
          return
        }

        this.selectedSwatchTitle.innerHTML = `${label} ${title}`

        this.handleUrlUpdate(event.target.value)
        this.handleInventoryUpdate(event.target.dataset.quantity)

        publish(PUB_SUB_EVENTS.addOnUpdate, { variantId: event.target.value })
      }

      handleUrlUpdate(addOnVariantId) {
        if (!addOnVariantId) {
          return
        }

        const url = new URL(location.href)
        url.searchParams.set('addOn', addOnVariantId)

        window.history.replaceState({}, '', url);
        this.handleGalleryUpdate()
      }

      handleInventoryUpdate(quantity) {
        if (!quantity) {
          return
        }

        const element = document.getElementById(`Inventory-${this.dataset.sectionId}`)
        const currentQuantity = Number(element.dataset.qty)

        if (Number(quantity) > currentQuantity) {
          return
        }

        if (Number(quantity) <= this.dataset.stockThreshold) {
          element.innerHTML = `${variantStrings.availability.replace('{{ quantity }}', quantity)}`
        } else {
          element.innerHTML = ''
        }
      }

      async handleGalleryUpdate() {
        const galleryElement = document.querySelector('.product__media-wrapper')
        const modalElement = document.querySelector('product-modal')
        const url = new URL(location.href)

        try {
          galleryElement.classList.add('loading')

          const response = await fetch(url.pathname + url.search)
          const responseText = await response.text()
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const newGalleryElement = html.querySelector('.product__media-wrapper')
          const newModalElement = html.querySelector('product-modal')

          galleryElement.innerHTML = newGalleryElement.innerHTML
          modalElement.innerHTML = newModalElement.innerHTML
        } catch (err) {
          console.error(err)
        } finally {
          galleryElement.classList.remove('loading')
        }
      }

      disconnectedCallback() {
        if (this.variantIdChangedUnsubscriber) {
          this.variantIdChangedUnsubscriber()
        }
      }
    }
  )
}
